<template>
  <article class="description">
    <section class="description__intro">
      <h3 class="description__title" data-anim="title">
        {{ description.title }}
      </h3>
      <p class="description__content" v-html="description.description" data-anim="text">
        {{ description.description }}
      </p>
    </section>

    <section class="description__boxes">
      <DescriptionBox
        class="description__box"
        v-for="item in description.list"
        :key="item.order"
        :data="item"
      >
      </DescriptionBox>
    </section>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';

import DescriptionBox from '@/components/DescriptionBox';

export default {
  name: 'Description',

  components: {
    DescriptionBox,
  },

  data() {
    return {
      description: {},
    };
  },

  computed: {
    ...mapGetters(['getDataCityComponent']),
  },

  created() {
    this.description = this.getDataCityComponent(this.$route.params.city, 'description');
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.description {
  position: relative;
  padding: 60px 0;

  @include mq(sm) {
    padding: 120px 0;
  }

  color: $color-dark-gray;
  background-color: $color-light;

  &__intro {
    padding: 0 40px;

    @include mq(sm) {
      padding: 0 100px;
    }
  }

  &__content {
    padding-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Description.vue